/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationNotifications200ResponseInner
 */
export interface GetReservationNotifications200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotifications200ResponseInner
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotifications200ResponseInner
     */
    notificationType: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotifications200ResponseInner
     */
    customizableEmailText: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotifications200ResponseInner
     */
    notifyBySms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotifications200ResponseInner
     */
    notifyByWhatsapp: boolean;
}

/**
 * Check if a given object implements the GetReservationNotifications200ResponseInner interface.
 */
export function instanceOfGetReservationNotifications200ResponseInner(value: object): value is GetReservationNotifications200ResponseInner {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('customizableEmailText' in value) || value['customizableEmailText'] === undefined) return false;
    if (!('notifyBySms' in value) || value['notifyBySms'] === undefined) return false;
    if (!('notifyByWhatsapp' in value) || value['notifyByWhatsapp'] === undefined) return false;
    return true;
}

export function GetReservationNotifications200ResponseInnerFromJSON(json: any): GetReservationNotifications200ResponseInner {
    return GetReservationNotifications200ResponseInnerFromJSONTyped(json, false);
}

export function GetReservationNotifications200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationNotifications200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'notificationType': json['notificationType'],
        'customizableEmailText': json['customizableEmailText'],
        'notifyBySms': json['notifyBySms'],
        'notifyByWhatsapp': json['notifyByWhatsapp'],
    };
}

export function GetReservationNotifications200ResponseInnerToJSON(json: any): GetReservationNotifications200ResponseInner {
    return GetReservationNotifications200ResponseInnerToJSONTyped(json, false);
}

export function GetReservationNotifications200ResponseInnerToJSONTyped(value?: GetReservationNotifications200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'notificationType': value['notificationType'],
        'customizableEmailText': value['customizableEmailText'],
        'notifyBySms': value['notifyBySms'],
        'notifyByWhatsapp': value['notifyByWhatsapp'],
    };
}

